import { createAction, props } from '@ngrx/store';
import { OrganizationPart } from './organization-part.model';

export const fetchOrganizationParts = createAction(
    '[Organization Parts]: Fetch organization parts',
    props<{
        organizationId: number;
    }>()
);

export const fetchOrganizationPartsSuccess = createAction(
    '[Organization Parts]: Fetch organization parts succeeded',
    props<{
        organizationParts: OrganizationPart[];
    }>()
);

export const fetchOrganizationPartsFailed = createAction(
    '[Organization Parts]: Fetch organization parts failed',
    props<{ error: Error }>()
);

export const selectOrganizationPart = createAction(
    '[Organization Parts]: Select organization part',
    props<{
        organizationPartId: string;
    }>()
);

export const upsertOrganizationParts = createAction(
    '[Organization Parts]: Upsert organization parts',
    props<{
        organizationParts: OrganizationPart[];
    }>()
);

export const fetchOrganizationPartsByIds = createAction(
    '[Organization Parts]: Fetch organization parts by IDs',
    props<{
        organizationPartIds: number[];
    }>()
);

export const fetchOrganizationPartsByIdsSuccess = createAction(
    '[Organization Parts]: Fetch organization parts by IDs succeeded',
    props<{
        organizationParts: OrganizationPart[];
    }>()
);

export const fetchOrganizationPartsByIdsFailed = createAction(
    '[Organization Parts]: Fetch organization parts by IDs failed',
    props<{ error: Error }>()
);
